import * as React from "react";
import styled from "@emotion/styled";
import { RiErrorWarningLine } from "@remixicon/react";
import Typography from "@mui/material/Typography";
const Required = styled.span(({ theme }) => ({
    color: theme.custom.colors.lightRed,
    marginLeft: "4px",
}));
const Description = styled.div(({ theme, error }) => [
    Object.assign(Object.assign({}, theme.typography.body2), { color: error
            ? theme.custom.colors.lightRed
            : theme.custom.colors.silverGrayDark }),
    error && {
        textIndent: "-24px",
        paddingLeft: "24px",
        "> svg:first-of-type": {
            marginRight: "4px",
            transform: "translateY(2px)",
            width: "18px",
            height: "18px",
            position: "relative",
            top: "2px",
        },
    },
]);
const Container = styled.div(({ fullWidth }) => [
    {
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "start",
        "> *:not(:last-child)": {
            marginBottom: "4px",
        },
    },
    fullWidth && {
        width: "100%",
    },
]);
const ControlLabel = ({ htmlFor, label, required, id, fullWidth, }) => {
    return (React.createElement(Typography, { id: id, component: "label", htmlFor: htmlFor, variant: "subtitle2", sx: { marginBottom: "4px", width: fullWidth ? "100%" : "auto" } },
        label,
        required ? React.createElement(Required, { "aria-hidden": "true" }, "*") : null));
};
const FormFieldWrapper = ({ label, required, helpText, error, errorText, className, fullWidth, id, children, }) => {
    const fallbackInputId = React.useId();
    const inputId = id || fallbackInputId;
    const helpId = React.useId();
    const errorId = React.useId();
    const labelId = React.useId();
    /**
     * aria-errormessage would be more semantic for the error message but has
     * somewhat limited support. See https://github.com/w3c/aria/issues/2048 for
     * some related information.
     */
    const describedBy = [helpText && helpId, error && errorText && errorId]
        .filter(Boolean)
        .join(" ") || undefined;
    return (React.createElement(Container, { className: className, fullWidth: fullWidth },
        React.createElement(ControlLabel, { htmlFor: inputId, id: labelId, label: label, required: required, fullWidth: fullWidth }),
        children({
            id: inputId,
            error,
            required,
            labelId,
            fullWidth,
            "aria-describedby": describedBy,
        }),
        helpText && React.createElement(Description, { id: helpId }, helpText),
        error && errorText && (React.createElement(Description, { id: errorId, error: true },
            React.createElement(RiErrorWarningLine, { fontSize: "inherit" }),
            errorText))));
};
export { FormFieldWrapper, ControlLabel, Description };
